export default __webpack_public_path__ + "static/media/sign_pod.f63cb10d.svg";